import CONSTANTES from "../constantes";


export const actionGetProducts = (page, filters) => ({
    type: CONSTANTES.GET_PRODUCTS,
    page,
    filters
})

export const actionGetProductDetail = (idProducto) => ({
    type: CONSTANTES.GET_PRODUCT_DETAIL,
    idProducto
})

export const openNewProductModal = () => {
    return {
        type: CONSTANTES.OPEN_NEW_MODAL_PRODUCT
    };
}

export const closeNewProductModal = () => {
    return {
        type: CONSTANTES.CLOSE_NEW_MODAL_PRODUCT
    };
}

export const openEditProductModal = (data) => {
    return {
        type: CONSTANTES.OPEN_EDIT_MODAL_PRODUCT,
        data
    };
}

export const closeEditProductModal = () => {
    return {
        type: CONSTANTES.CLOSE_EDIT_MODAL_PRODUCT
    }
}

export const actionAddProduct= values => ({
    type: CONSTANTES.ADD_PRODUCT,
    values,
})

export const actionAddProductSuccess = (product,total) => ({
    type: CONSTANTES.ADD_PRODUCT_SUCCESS,
    payload:product,
    total
})

export const actionEditProduct = (values,idInfoProduct) => ({
    type: CONSTANTES.UPDATE_PRODUCT,
    values,
    idInfoProduct
})

export const actionEditProductSuccess = product => ({
    type: CONSTANTES.UPDATE_PRODUCT_SUCCESS,
    product,
})

export const actionGetConfigTarifasRequest=()=>({
    type:CONSTANTES.GET_CONFIG_TARIFAS
})

export const actionGetConfigTarifasSuccess=(data)=>({
    type:CONSTANTES.GET_CONFIG_TARIFAS_SUCCESS,
    data
})

export const actionEditConfigTarifasRequest=(values, idConfigTarifa)=>({
    type:CONSTANTES.EDIT_TARIFAS_REQUEST,
    values,
    idConfigTarifa
})

export const actionEditConfigTarifasSuccess=(data)=>({
    type:CONSTANTES.EDIT_TARIFAS_REQUEST_SUCCESS,
    data
})


export const actionFilterProducts=(page,filters)=>({
    type:CONSTANTES.FILTER_PRODUCTS,
    page,
    filters
})


export const actionGetFilesProduct=(idProduct)=>({
    type:CONSTANTES.GET_FILES_PRODUCTS_REQUEST,
    idProduct
})

export const actionGetFilesProductSuccess=(files)=>({
    type:CONSTANTES.GET_FILES_PRODUCTS_SUCCESS,
    files
})

export const actionAddFileProductRequest=(file)=>({
    type:CONSTANTES.ADD_PRODUCT_FILE_REQUEST,
    file
})

export const actionAddFileProductSuccess=(newFile)=>({
    type:CONSTANTES.ADD_PRODUCT_FILE_SUCCESS,
    newFile
})

export const actionEditFileProductRequest=(idFile,file)=>({
    type:CONSTANTES.EDIT_PRODUCT_FILE_REQUEST,
    idFile,
    file
})

export const actionEditFileProductSuccess=(fileObject)=>({
    type:CONSTANTES.EDIT_PRODUCT_FILE_SUCCESS,
    fileObject
})

export const actionDeleteFileProductRequest=(file)=>({
    type:CONSTANTES.DELETE_PRODUCT_FILE_REQUEST,
    file
})